angular.module('inspinia').factory('authEmployeeService', function () {
  let state = {
    // ログインしている職員情報
    authEmployee: {},
  };

  // Getters
  /**
   * @returns authEmployee
   */
  const getAuthEmployee = () => {
    return state.authEmployee;
  };

  // Mutations
  /**
   * @param {*} employee
   */
  const setAuthEmployee = function (employee) {
    state.authEmployee = {
      employeeId: employee.id,
      employeeName: employee.name,
      thumbnailUrl: employee.thumbnail_url,
      deletedAt: employee.delete_datetime,
      manageFacility: employee.manage_service,
    };
  };

  // Actions

  return {
    ...state,
    getAuthEmployee,
    setAuthEmployee,
  };
});
